import { SxProps } from "@mui/material";

export const sxError: SxProps = {
    color: '#D84141',
    fontSize: '12px'
}

export const sxRadioButton: SxProps = {
    marginBottom: '24px'
}

export const sxRadio: SxProps = {
    '.MuiFormControlLabel-label': {
        fontSize: '14px'
    } 
}

export const sxSubtitle: SxProps = {
    color: '#383838',
    fontWeight: 600,
    fontSize: '14px'
}

export const sxLabel: SxProps = {
    color: '#383838',
    fontWeight: 600,
    marginBottom: '16px'
}
